const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let analyticsInitialized = false;

const getScriptId = () => 'ga4-gtag-script';

const isReactSnapPrerender = () => {
  if (typeof window !== 'undefined') {
    // react-snap injects globals while crawling pages in headless Chromium.
    if (window.__REACT_SNAP__ || typeof window.snapSaveState === 'function') {
      return true;
    }
  }

  if (typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent || '';
  return ua.includes('ReactSnap') || ua.includes('HeadlessChrome');
};

const isAnalyticsEnabled = () => hasAnalyticsConfig && !isReactSnapPrerender();

export const hasAnalyticsConfig = Boolean(GA_MEASUREMENT_ID);

export const initAnalytics = () => {
  if (!isAnalyticsEnabled() || analyticsInitialized || typeof window === 'undefined') {
    return;
  }

  const scriptId = getScriptId();
  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false,
    anonymize_ip: true,
  });

  analyticsInitialized = true;
};

export const trackPageView = (pagePath) => {
  if (!isAnalyticsEnabled() || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (eventName, params = {}) => {
  if (!isAnalyticsEnabled() || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', eventName, params);
};
